module.exports = __webpack_public_path__ + "img/cierre.3f3a8dc6.svg";